// 9fbef606107a605d69c0edbcd8029e5d
const analyticsFormValues = {
  plcc: {
    formName: 'plcc',
    formFields: {
      firstName: 'firstname',
      middleNameInitial: 'middlenameinitial',
      lastName: 'lastname',
      addressLine1: 'addressline1',
      addressLine2: 'addressline2',
      city: 'city',
      statewocountry: 'state',
      noCountryZip: 'zipcode',
      phoneNumberWithAlt: 'altphonenumber',
      altPhoneNumber: 'phonenumber',
      emailAddress: 'emailaddress',
      month: 'birthmonth',
      iAgree: 'plcctermsandconditions',
      ssNumber: 'ssn',
      prescreencode: 'prescreencode',
      country: 'country',
      date: 'birthdate',
      year: 'birthyear',
    },
  },
  checkoutBilling: {
    formName: 'checkoutBilling',
    formFields: {
      paymentMethodId: 'paymentMethodId',
      cardNumber: 'cardnumber',
      expMonth: 'expmonth',
      expYear: 'expyear',
      'address.firstName': 'firstname',
      'address.lastName': 'lastname',
      'address.addressLine1': 'addressline1',
      'address.addressLine2': 'addressline2',
      'address.city': 'city',
      'address.zipCode': 'zipcode',
      // was not required
      cvvCode: 'cvvCode',
      cardType: 'cardType',
      sameAsShipping: 'sameAsShipping',
      'address.state': 'address.state',
      'address.country': 'address.country',
      recaptchaToken: 'recaptchaToken',
    },
  },
  login: {
    formName: 'login',
    formFields: {
      recaptchaToken: 'recaptchatoken',
      password: 'password',
      emailAddress: 'emailaddress',
    },
  },
  personalInformation: {
    formName: 'personalinformation',
    formFields: {
      firstName: 'firstname',
      lastName: 'lastname',
      Email: 'emailaddress',
      phoneNumber: 'phonenumber',
      userBirthMonth: 'userBirthMonth',
      userBirthYear: 'userBirthYear',
      isEmployee: 'isEmployee',
      addressLine1: 'addressline1',
      addressLine2: 'addressline2',
      city: 'city',
      state: 'state',
      zipCode: 'zipcode',
      country: 'country',
      airmilesaccountnumber: 'airmilesaccountnumber',
    },
  },
  checkoutShipping: {
    formName: 'checkoutShipping',
    formFields: {
      'address.firstName': 'firstname',
      'address.lastName': 'lastname',
      'address.addressLine1': 'addressline1',
      'address.addressLine2': 'addressline2',
      'address.city': 'city',
      'address.state': 'state',
      'address.zipCode': 'zipcode',
      'address.phoneNumber': 'phonenumber',
      'address.country': 'country',
      'address.emailAddress': 'emailaddress',
      'smsSignUp.phoneNumber': 'smsupdatenumber',
      'shipmentMethods.shippingMethodId': 'shippingmethodid',
      // couldn't find following
      message: 'message',
      smsmarketingnumber: 'smsmarketingnumber',
      'smsSignUp.sendOrderUpdate': 'sendOrderUpdate',
    },
  },

  createAccount: {
    formName: 'createaccountform',
    formFields: {
      firstName: 'firstName',
      lastName: 'lastName',
      phoneNumber: 'phoneNumber',
      noCountryZip: 'zipCode',
      emailAddress: 'emailAddress',
      password: 'password',
      confirmPassword: 'confirmPassword',
      iAgree: 'termsAndConditions',
      // following are new and, was not available on analytics requirement
      hideShowPwd: 'hideShowPwd',
      confirmHideShowPwd: 'confirmHideShowPwd',
      rememberMe: 'rememberMe',
    },
  },
  addOrEditCreditCard: {
    formName: 'addoreditcreditcard',
    formFields: {
      addressLine1: 'addressline1',
      addressLine2: 'addressline2',
      city: 'city',
      state: 'state',
      zipCode: 'zipcode',
      firstName: 'firstname',
      lastName: 'lastname',
      country: 'country',
      cardnumber: 'cardnumber',
      expyear: 'expyear',
      expmonth: 'expmonth',
    },
  },
  addChild: {
    formName: 'addchild',
    formFields: {
      childName: 'childname',
      acceptAddChildAgreement: 'agreetermandconditions',
      firstName: 'digitalsignaturelastname',
      lastName: 'digitalsignaturefirstname',
      gender: 'gender',
      childBirthMonth: 'childBirthMonth',
      childBirthYear: 'childBirthYear',
    },
  },
  addGiftCardCard: {
    formName: 'addgiftcardcard',
    formFields: {
      giftCardNumber: 'cardnumber',
      cardPin: 'cardpin',
      recaptchaToken: 'recaptchatoken',
    },
  },
  checkoutPickup: {
    formName: 'checkoutpickup',
    formFields: {
      smsUpdateNumber: 'smsupdatenumber',
      firstName: 'firstname',
      lastName: 'lastname',
      phoneNumber: 'phonenumber',
      emailAddress: 'emailaddress',
    },
  },
  editorAddaddress: {
    formName: 'editoraddaddress',
    formFields: {
      firstName: 'firstname',
      lastName: 'lastname',
      addressLine1: 'addressline1',
      addressLine2: 'addressline2',
      city: 'city',
      state: 'state',
      zipCode: 'zipcode',
      country: 'country',
      phoneNumber: 'phonenumber',
    },
  },
};

const formConversions = {
  LoginForm: analyticsFormValues.login,
  myLoginForm: analyticsFormValues.login,
  AddressForm: analyticsFormValues.editorAddaddress,
  CreateAccountForm: analyticsFormValues.createAccount,
  myCreateAccountForm: analyticsFormValues.createAccount,
  checkoutPickup: analyticsFormValues.checkoutPickup,
  checkoutBilling: analyticsFormValues.checkoutBilling,
  checkoutBillingPayment: analyticsFormValues.checkoutBilling,
  checkoutCardEditPayment: analyticsFormValues.checkoutBilling,
  checkoutShipping: analyticsFormValues.checkoutShipping,
  addEditCreditCard: analyticsFormValues.addOrEditCreditCard,
  AddEditPersonalInformationForm: analyticsFormValues.personalInformation,
  AddGiftCardForm: analyticsFormValues.addGiftCardCard,
  AddGiftCardMobileForm: analyticsFormValues.addGiftCardCard,
  AddChildBirthdayForm: analyticsFormValues.addChild,
  PLCCForm: analyticsFormValues.plcc,
};

export default formConversions;
